import React from 'react'

function Section({
  heading,
  note = '',
  children,
  className = 'max-view-page mh1'
}) {
  return (
    <div className="mb6">
      <div className="max-view-page mh1">
        <h2 className="ttu b mbr mb4 accent">{heading}</h2>
        {note && <div className="mb4 i">{note}</div>}
      </div>
      <div className={className}>{children}</div>
    </div>
  )
}

export default Section
